import { useEffect, useCallback, useRef } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export const useGoogleAnalyticsPublic = ({ enable, gaId }) => {
  const location = useLocation();
  const initializedRef = useRef(false);
  const currentGaIdRef = useRef(null);

  // Initialize GA only once per ID
  useEffect(() => {
    if (!enable || !gaId) return;

    // Only initialize if not already initialized or if GA ID changed
    if (!initializedRef.current || currentGaIdRef.current !== gaId) {
      ReactGA.initialize(gaId);
      initializedRef.current = true;
      currentGaIdRef.current = gaId;
    }
  }, [enable, gaId]);

  // Track page views on route changes
  useEffect(() => {
    if (!enable || !gaId || !initializedRef.current) return;

    ReactGA.send("pageview", {
      page: location.pathname + location.search,
    });
  }, [enable, gaId, location.pathname, location.search]);

  // Return a function to track custom events
  const trackEvent = useCallback(
    (eventName, eventParams = {}) => {
      if (!enable || !gaId || !initializedRef.current) return;

      ReactGA.event(eventName, eventParams);
    },
    [enable, gaId]
  );

  return trackEvent;
};
